module.exports = __webpack_public_path__ + "static/media/Sub 6.21fc18bf.jpg";